(function (module) {
    "use strict";
    module.service('ppgCalculationService', ['synchronousEventsBus', 'forecastCacheService', 'calculationPPGService',
        function(
            this: $TSFixMe,
            synchronousEventsBus: $TSFixMe,
            forecastCacheService: $TSFixMe,
            calculationPPGService: $TSFixMe
        ) {
            var service = this;

            service.registerEvents = function () {

                synchronousEventsBus.$on('brandValueForecastChanged', function (event: $TSFixMe, args: $TSFixMe) {
                    return service.calculateBrandYearlySum(args);
                });

                synchronousEventsBus.$on('chamferingBrandValueForecastChanged', function (event: $TSFixMe, args: $TSFixMe) {
                    return service.calculateBrandYearlySum(args);
                });

                synchronousEventsBus.$on('value.pmForecastChanged', function (event: $TSFixMe, args: $TSFixMe) {
                    return service.calculateBrandYearlySum(args);
                });

                synchronousEventsBus.$on('sku.BrandValueCalculated', function (event: $TSFixMe, args: $TSFixMe) {
                    return service.calculateBrandYearlySum(args);
                });
            };

            service.calculateBrandYearlySum = function (args: $TSFixMe) {
                let {
                    parameters,
                    market: {
                        brands: brands
                    }
                } = forecastCacheService.getForecast();
                
                const len = moment(parameters.forecastEndDate).diff(parameters.historicalDataStart, 'years') + 1;
                for (let brand of brands) {
                    brand = updateBrand(brand, parameters, len);
                }
            };

            const updateBrand = (brand: $TSFixMe, parameters: $TSFixMe, len: $TSFixMe) => {

                if (angular.isUndefinedOrNull(brand.forecast) || angular.isUndefinedOrNull(brand.forecast.value)) {
                    return brand;
                }

                //@ts-ignore
                let brandYearlySum = _.times(len, _.constant(null));

                if (!angular.isUndefinedOrNull(brand.forecast.historicalValueData) &&

                    !angular.isUndefinedOrNull(brand.forecast.value.pmForecast)) {
                    let brandValue = brand.forecast.historicalValueData.concat(brand.forecast.value.pmForecast);
                    var startMonth = brand.forecast.historicalValueData.length == 0 ? parameters.forecastStartDate : parameters.historicalDataStart;
                    brandYearlySum = calculationPPGService.sumBy(brandValue, startMonth, (month: $TSFixMe) => month == 0);
                }

                return buildCustomData(brand, parameters, brandYearlySum);
            };

            const buildCustomData = function (brand: $TSFixMe, {
                forecastStartDate,
                forecastEndDate
            }: $TSFixMe, brandYearlySum: $TSFixMe) {
                const labels = enumarateYearsBetween(forecastStartDate.getFullYear(), forecastEndDate.getFullYear());
                const values = brandYearlySum.slice(-labels.length);
                addCustomFieldIfNeeded(brand, labels.length);
                brand.customData.values.labels = labels;
                brand.customData.values.originalValues = values;
                return brand;
            };

            const addCustomFieldIfNeeded = function (brand: $TSFixMe, len: $TSFixMe) {
                if (!brand.hasOwnProperty('customData') || !brand.customData) {
                    brand.customData = {};
                };

                if (!brand.customData.hasOwnProperty('values') || !brand.customData.values) {
                    brand.customData.values = {
                        //@ts-ignore
                        customValues: _.times(len, _.constant(null))
                    };
                }
            };

            const enumarateYearsBetween = function (rangeStart: $TSFixMe, rangeEnd: $TSFixMe) {
                let values = [];
                for (let i = rangeStart; i <= rangeEnd; ++i) {
                    values.push(i);
                }

                return values;
            };
        }
    ]);

    module.run(['ppgCalculationService', function (service: $TSFixMe) {
        service.registerEvents();
    }]);

})(angular.module('topline.services'));